<template>
  <div id="app" class="page" :class="[isRTL ? 'rtl' : '']">
    <alert :alertData="alert_data"/>
    <template v-if="isAuth">
      <div class="container-fluid">
        <toolbar v-if="!isPrint"/>
        <div class="row">
          <aside class="col-auto aside-table" v-if="!isPrint">
            <sidenav/>
          </aside>

          <main class="overflow-x-hidden" :class="isPrint ? '' : 'col'">
            <router-view @alert="alert"/>
          </main>

        </div>
      </div>
    </template>
    <template v-else>
      <login @alert="alert"/>
    </template>
  </div>
</template>
<script>

  import toolbar from '@/components/toolbar'
  import sidenav from '@/components/sidenav'
  import alert from '@/components/alert'
  import login from '@/views/Login'
  import pelecard_callback from '@/components/pelecard_callback'
  import router from '@/router'


  export default {
    components: {toolbar, sidenav, login, alert, pelecard_callback},
    data() {
      return {
        alert_data: {
          type: '',
          body: '',
        }
      }
    },
    computed: {
      isAuth() {
        return this.$store.getters.isAuth
      },
      isRTL() {
        return this.$store.getters.isRTL
      },
      isPrint(){
        return this.$route.name === 'Print'
      }
    },
    created() {
      this.$store.dispatch('tryAutoLogin')
        .then((res) => {
          if (res) {
            // router.replace('/dashboard')
          }
        })
    },
    methods: {
      alert(type, msg) {
        this.alert_data.type = type
        this.alert_data.body = msg
        setTimeout(() => {
          this.alert_data.type = ''
          this.alert_data.body = ''
        }, 3000)
      }
    }
  }

</script>

